import { Component } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent, RouterOutlet } from '@angular/router';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { environment } from 'environments/environment';
import { SharedModule } from './shared/shared.module';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone: true,
    imports: [
        SharedModule,
        RouterOutlet
    ],
})
export class AppComponent
{
    ambient = environment.ambientserver;
    version = environment.version;

    constructor(
        private _router: Router,
        private _splashSrv: FuseSplashScreenService
    )
    {
        this._router.events.subscribe((e: any) => this.navigationInterceptor(e));
    }

    navigationInterceptor(event: RouterEvent): void
    {
        if (event instanceof NavigationStart) {
            this._splashSrv.show();
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
            this._splashSrv.hide();
        }
    }
}
